




























































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import { FAQ, FAQCategory, Business, Role } from "@/types";

const { mapActions: faqActions } = createNamespacedHelpers("FAQ_");
const { mapActions: categoryActions, mapGetters: categoryGetters } =
  createNamespacedHelpers("FAQ_CATEGORY_");

interface VForm extends Vue {
  validate(): boolean;
  reset(): void;
}

export default Vue.extend({
  name: "FAQForm",
  props: {
    faq: {
      type: Object as () => FAQ | null,
      default: null,
    },
  },
  data() {
    return {
      valid: false,
      loading: false,
      loadingCategories: false,
      formData: {
        question: "",
        answer: "",
        category: "",
        order: 1,
      },
      questionRules: [
        (v: string) => !!v || "Question is required",
        (v: string) =>
          (v && v.length <= 200) || "Question must be less than 200 characters",
      ],
      answerRules: [(v: string) => !!v || "Answer is required"],
      categoryRules: [(v: string) => !!v || "Category is required"],
    };
  },
  computed: {
    ...categoryGetters(["categoryPage"]),
    role(): Role {
      return this.$store.getters.role;
    },
    isEdit(): boolean {
      return !!this.faq;
    },
    categories(): FAQCategory[] {
      return this.categoryPage?.docs || [];
    },
    businessId(): string {
      if (!this.role || !this.role.business) return "";

      return typeof this.role.business === "string"
        ? this.role.business
        : (this.role.business as Business)._id;
    },
  },
  methods: {
    ...faqActions(["createFAQ", "updateFAQ"]),
    ...categoryActions(["fetchCategoryList"]),
    resetForm() {
      if (this.$refs.form) {
        (this.$refs.form as VForm).reset();
      }
      this.formData = {
        question: "",
        answer: "",
        category: "",
        order: 1,
      };
    },
    populateForm() {
      if (this.faq) {
        this.formData = {
          question: this.faq.question || "",
          answer: this.faq.answer || "",
          category:
            typeof this.faq.category === "string"
              ? this.faq.category
              : this.faq.category?._id || "",
          order: this.faq.order || 1,
        };
      }
    },
    loadCategories() {
      if (this.businessId) {
        this.loadingCategories = true;
        this.fetchCategoryList({
          businessId: this.businessId,
          page: 1,
          limit: 50,
          sort: "order",
        }).finally(() => {
          this.loadingCategories = false;
        });
      }
    },
    async submitForm() {
      if (this.$refs.form) {
        if (!(this.$refs.form as VForm).validate()) {
          return;
        }
      }

      this.loading = true;

      try {
        if (this.role) {
          // Get the business ID
          const businessId =
            typeof this.role.business === "string"
              ? this.role.business
              : (this.role.business as Business)._id;

          // Create payload
          const payload = {
            ...this.formData,
            business: businessId,
          };

          console.log("FAQ payload:", payload);

          if (this.isEdit && this.faq) {
            await this.updateFAQ({
              faqId: this.faq._id,
              data: payload,
            });
          } else {
            await this.createFAQ(payload);
          }

          this.$emit("refresh");
          this.$emit("close");
        }
      } catch (error) {
        console.error("Error submitting form:", error);

        // Show error notification
        this.$store.dispatch("setToast", {
          title: "Error",
          type: "error",
          text: "Failed to save FAQ. Please try again.",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.loadCategories();
    this.populateForm();
  },
  watch: {
    faq: {
      handler() {
        this.populateForm();
      },
      deep: true,
    },
  },
});
